import { useState, useEffect, useCallback } from "react";
import { listAccounts, createAccount, updateAccount, deleteAccount } from "../../api/endpoints/accounts.js";
function accountMatchesSearch(account, q) {
  const hay = [
    account.companyName,
    account.legalName,
    account.industry,
    account.city,
    account.state,
    account.status,
    account.tier,
    account.contact?.name,
    account.contact?.email,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  return hay.includes(q);
}

export function useAccounts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [saving, setSaving] = useState(false);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await listAccounts();
      setItems(data);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const visible = search.trim()
    ? items.filter((a) => accountMatchesSearch(a, search.trim().toLowerCase()))
    : items;

  const saveAccount = useCallback(async (payload) => {
    setSaving(true);
    try {
      const exists = items.some((x) => x.id === payload.id);
      const saved = exists ? await updateAccount(payload) : await createAccount(payload);
      setItems((list) => {
        const i = list.findIndex((x) => x.id === saved.id);
        if (i >= 0) {
          const next = [...list];
          next[i] = saved;
          return next;
        }
        return [saved, ...list];
      });
      return saved;
    } finally {
      setSaving(false);
    }
  }, [items]);

  const removeAccount = useCallback(async (id) => {
    await deleteAccount(id);
    setItems((list) => list.filter((x) => x.id !== id));
  }, []);

  return {
    items: visible,
    allItems: items,
    loading,
    error,
    search,
    setSearch,
    reload,
    saveAccount,
    removeAccount,
    saving,
    total: items.length,
  };
}
